import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col relative" }
const _hoisted_2 = { class: "px-4 md:px-10 xl:px-20 flex flex-col border-b-[0.5px] border-black-300" }
const _hoisted_3 = {
  ref: "flyoutContainer",
  class: "absolute top-full inset-x-0 bg-white transition-[height] duration-300 ease-in-out px-20 z-50"
}
const _hoisted_4 = {
  key: 0,
  class: "lg:hidden fixed top-16 inset-x-0 bottom-0 px-4 md:px-10 bg-white border-t-[0.5px] border-black-300 overflow-y-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollapseTransition = _resolveComponent("CollapseTransition")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_CollapseTransition, {
      name: "nav-collapse",
      onBeforeEnter: _cache[0] || (_cache[0] = ($event: any) => ($options.setCollapseAnimating(true))),
      onAfterEnter: _cache[1] || (_cache[1] = ($event: any) => ($options.setCollapseAnimating(false))),
      onBeforeLeave: _cache[2] || (_cache[2] = ($event: any) => ($options.setCollapseAnimating(true))),
      onAfterLeave: _cache[3] || (_cache[3] = ($event: any) => ($options.setCollapseAnimating(false)))
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {
            collapseMetaNav: $options.collapseMetaNav,
            setCollapseAnimating: $options.setCollapseAnimating,
            activeFlyoutItem: $data.activeFlyoutItem,
            toggleFlyout: $options.toggleFlyout,
            mobileNavOpened: $data.mobileNavOpened,
            toggleMobileNav: $options.toggleMobileNav,
            globalNavOpened: _ctx.globalNavOpened,
            openGlobalNav: $options.openGlobalNav,
            searchOpened: _ctx.searchOpened,
            toggleSearch: $options.toggleSearch
          })
        ], 512), [
          [_vShow, !$options.collapseMainNav]
        ])
      ]),
      _: 3
    }),
    (_openBlock(), _createBlock(_Teleport, {
      to: $options.flyoutTeleportTarget,
      disabled: !$data.activeFlyoutItem
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          name: "flyout-fade",
          mode: "out-in",
          onBeforeEnter: $options.updateFlyoutHeight,
          onAfterLeave: $options.resetFlyoutHeight
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "flyout", {
              activeFlyoutItem: $data.activeFlyoutItem,
              activeSubItem: $data.activeSubItem,
              toggleSubItem: $options.toggleSubItem,
              updateFlyoutHeight: $options.updateFlyoutHeight,
              focusFirst: $options.focusFirst
            })
          ]),
          _: 3
        }, 8, ["onBeforeEnter", "onAfterLeave"])
      ], 512)
    ], 8, ["to", "disabled"])),
    _renderSlot(_ctx.$slots, "subsite-nav", {
      activeSubsiteFlyout: $data.activeSubsiteFlyout,
      toggleSubsiteFlyout: $options.toggleSubsiteFlyout,
      activeSubsiteL2Item: $data.activeSubsiteL2Item,
      toggleSubsiteL2Item: $options.toggleSubsiteL2Item,
      mobileSubsiteNavOpened: $data.mobileSubsiteNavOpened,
      toggleMobileSubsiteNav: $options.toggleMobileSubsiteNav,
      activeMobileSubsiteItem: $data.activeMobileSubsiteItem,
      toggleMobileSubsiteItem: $options.toggleMobileSubsiteItem,
      activeMobileSubsiteL2Item: $data.activeMobileSubsiteL2Item,
      toggleMobileSubsiteL2Item: $options.toggleMobileSubsiteL2Item,
      inert: !!$data.activeFlyoutItem || $data.mobileNavOpened,
      updateSubsiteFlyoutHeight: $options.updateSubsiteFlyoutHeight,
      releaseSubsiteFlyoutHeight: $options.releaseSubsiteFlyoutHeight,
      freezeSubsiteFlyoutHeight: $options.freezeSubsiteFlyoutHeight,
      resetSubsiteFlyoutHeight: $options.resetSubsiteFlyoutHeight
    }),
    _createVNode(_Transition, { name: "nav-slide-down-fade" }, {
      default: _withCtx(() => [
        ($data.mobileNavOpened)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "mobile-flyout", {
                activeMobileFlyoutItem: $data.activeMobileFlyoutItem,
                toggleMobileFlyout: $options.toggleMobileFlyout,
                activeMobileSubItem: $data.activeMobileSubItem,
                toggleMobileSubItem: $options.toggleMobileSubItem,
                openGlobalNav: $options.openGlobalNav
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _renderSlot(_ctx.$slots, "locale-guidance"),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "nav-fade" }, {
        default: _withCtx(() => [
          ($data.mobileNavOpened || $data.mobileSubsiteNavOpened || $data.activeFlyoutItem || $data.activeSubsiteFlyout)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 bg-black/50",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.closeAll && $options.closeAll(...args)))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    _renderSlot(_ctx.$slots, "global-nav-overlay"),
    _renderSlot(_ctx.$slots, "search-overlay", { searchOpened: _ctx.searchOpened })
  ]))
}